module.exports = __webpack_public_path__ + "static/media/home-step-icon-fc.65da4646.svg";